import { Theme } from "@mui/material";

const onboardingCardSizing = (theme: Theme) => ({
  [theme.breakpoints.only("xs")]: {
    width: "100%",
    height: "100%",
  },
  [theme.breakpoints.up("sm")]: {
    width: "600px",
    height: "600px",
    px: 4,
  },
});

export { onboardingCardSizing };
